export const CONFIG_STALE_TIME = 1000 * 60 * 60; // 1 hour

export const DEFAULT_CHECKER_INTERVAL = 2000; // miliseconds

export const EXTERNAL_REQUEST_ERROR_CODE = 900;
